export const MAX_MAP_PLOT_REQUEST_DETAILS = 5_000;
